export enum OrderTriggerName {
    ORDER_STATE_CHANGED = 'order_state_changed',
    ORDER_CANCEL = 'order_cancel',
    ORDER_CANCELLED = 'order_cancelled',
    ORDER_PLACED = 'order_placed'
}

export enum OrderActionName {
    ORDER_CHANGE_STATE = 'order_change_state',
    ORDER_NOTIFY_CC = 'order_notify_cc',
    ORDER_NOTIFY_ORDERER = 'order_notify_orderer',
    ORDER_UPDATE_BUDGET_USE = 'order_update_budget_use',
    ORDER_REMOVE_BUDGET_USE = 'order_remove_budget_use'
}
